import { Icon } from '@iconify/react';
import { Box, Container, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.paper,
        py: 5,
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Container maxWidth='lg'>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
          {/* Logo and Description */}
          <Box sx={{ width: { xs: '100%', md: '33%' } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Icon
                icon='mdi:alpha-s-box'
                width='40'
                height='40'
                style={{ marginRight: '10px', color: 'primary.main' }}
              />
              <Typography
                variant='h6'
                component='div'
                sx={{ color: '#fff', fontWeight: 'bold' }}
              >
                Skyfall Enterprises
              </Typography>
            </Box>
            <Typography
              variant='body2'
              sx={{ color: (theme) => theme.palette.text.secondary, mb: 3 }}
            >
              YSkyfall Enterprises is a leading data-driven software company,
              blending advanced software solutions with powerful analytics. We
              transform raw data into actionable insights, delivering tailored
              reporting that drives smarter decisions, boosts performance, and
              unlocks new opportunities. With Skyfall, data becomes your
              competitive edge.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <IconButton
                size='small'
                sx={{ color: '#fff', '&:hover': { color: 'text.primary' } }}
                onClick={() =>
                  window.open(
                    'https://www.facebook.com/profile.php?id=100084458424509',
                    '_blank'
                  )
                }
              >
                <Icon icon='mdi:facebook' width='20' height='20' />
              </IconButton>
              <IconButton
                size='small'
                sx={{ color: '#fff', '&:hover': { color: 'text.primary' } }}
                onClick={() =>
                  window.open(
                    'https://www.linkedin.com/company/skyfall-enterprisesa/',
                    '_blank'
                  )
                }
              >
                <Icon icon='mdi:linkedin' width='20' height='20' />
              </IconButton>
              <IconButton
                size='small'
                sx={{ color: '#fff', '&:hover': { color: 'text.primary' } }}
                onClick={() =>
                  window.open(
                    'https://www.instagram.com/skyfallenterprises/',
                    '_blank'
                  )
                }
              >
                <Icon icon='mdi:instagram' width='20' height='20' />
              </IconButton>
            </Box>
          </Box>

          {/* Quick Links */}
          <Box sx={{ width: { xs: '100%', md: '17%' } }}>
            <Typography
              variant='subtitle1'
              sx={{ color: '#fff', fontWeight: 600, mb: 2 }}
            >
              Quick Links
            </Typography>
            <Box component='ul' sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {[
                { label: 'Home', sectionId: 'hero' },
                { label: 'Services', sectionId: 'services' },
                { label: 'About', sectionId: 'about' },
                { label: 'Testimonials', sectionId: 'testimonials' },
                { label: 'Contact', sectionId: 'contactus' },
              ].map((item) => (
                <Box component='li' key={item.label} sx={{ mb: 1 }}>
                  <Typography
                    variant='body2'
                    component='a'
                    href='#'
                    onClick={(e) => {
                      e.preventDefault();
                      const element = document.getElementById(item.sectionId);
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                        window.location.hash = item.sectionId;
                      }
                    }}
                    sx={{
                      color: (theme) => theme.palette.text.secondary,
                      textDecoration: 'none',
                      '&:hover': { color: 'text.primary' },
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <Icon
                      icon='mdi:chevron-right'
                      width='16'
                      height='16'
                      style={{ marginRight: '4px' }}
                    />
                    {item.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Services */}
          {/* <Box sx={{ width: { xs: '100%', md: '17%' } }}>
            <Typography
              variant='subtitle1'
              sx={{ color: '#fff', fontWeight: 600, mb: 2 }}
            >
              Services
            </Typography>
            <Box component='ul' sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {[
                'Web Development',
                'Mobile Apps',
                'Business Development',
                'Business Intelligence',
                'UI/UX Design',
              ].map((item) => (
                <Box component='li' key={item} sx={{ mb: 1 }}>
                  <Typography
                    variant='body2'
                    component='a'
                    href='#'
                    sx={{
                      color: (theme) => theme.palette.text.secondary,
                      textDecoration: 'none',
                      '&:hover': { color: 'text.primary' },
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Icon
                      icon='mdi:chevron-right'
                      width='16'
                      height='16'
                      style={{ marginRight: '4px' }}
                    />
                    {item}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box> */}

          {/* Contact Info */}
          <Box sx={{ width: { xs: '100%', md: '33%' } }}>
            <Typography
              variant='subtitle1'
              sx={{ color: '#fff', fontWeight: 600, mb: 2 }}
            >
              Contact Info
            </Typography>
            {/* <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
              <Icon
                icon='mdi:map-marker'
                width='20'
                height='20'
                style={{
                  color: 'primary.main',
                  marginRight: '10px',
                  marginTop: '4px',
                }}
              />
              <Typography
                variant='body2'
                sx={{ color: (theme) => theme.palette.text.secondary }}
              >
                123 Tech Street, Innovation City, 10101
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Icon
                icon='mdi:email'
                width='20'
                height='20'
                style={{ color: 'primary.main', marginRight: '10px' }}
              />
              <Typography
                variant='body2'
                component='a'
                href='mailto:contact@skyfall-enterprises.com'
                sx={{
                  color: (theme) => theme.palette.text.secondary,
                  textDecoration: 'none',
                  '&:hover': { color: 'text.primary' },
                }}
              >
                contact@skyfall-enterprises.com
              </Typography>
            </Box> */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Icon
                icon='mdi:phone'
                width='20'
                height='20'
                style={{ color: 'primary.main', marginRight: '10px' }}
              />
              <Typography
                variant='body2'
                component='a'
                href='tel:+962797016535'
                sx={{
                  color: (theme) => theme.palette.text.secondary,
                  textDecoration: 'none',
                  '&:hover': { color: 'text.primary' },
                }}
              >
                +962-79-701-6535
              </Typography>
            </Box>
          </Box>
        </Stack>

        {/* Copyright */}
        <Box
          sx={{
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            mt: 4,
            pt: 3,
            textAlign: 'center',
          }}
        >
          <Typography
            variant='body2'
            sx={{ color: 'rgba(255, 255, 255, 0.5)' }}
          >
            © {new Date().getFullYear()} Skyfall Enterprises. All rights
            reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
